import { FlexRow, Panel } from '@epam/promo';
import { Outlet } from 'react-router-dom';

import { VerticalNavigationTabs } from 'components/nav/VerticalNavigationTabs';
import { settingsRoutes } from 'router/settingsRoutes';
import { useFeatureTogglesStore } from 'store/feature-toggling';

interface SubMenuItem {
  caption: string;
  pathname: string;
}

export const UserManagementPage = () => {
  const { isFeatureEnabled } = useFeatureTogglesStore();

  const applicationSettingsSubMenu: SubMenuItem[] = [
    { caption: 'Manage Users', pathname: settingsRoutes.users },
    ...(isFeatureEnabled('userGroupsRoles')
      ? [{ caption: 'Manage User Groups', pathname: settingsRoutes.userGroups }]
      : []),
  ];

  return (
    <FlexRow
      columnGap="24"
      rawProps={{
        style: { margin: '1rem auto', marginRight: '24px', height: '100%' },
      }}>
      <Panel shadow style={{ alignSelf: 'start' }}>
        <VerticalNavigationTabs menuItems={applicationSettingsSubMenu} />
      </Panel>
      <Outlet />
    </FlexRow>
  );
};
